// Single source of truth for the App Store listing URL, so a future ID or
// locale change is a one-line edit instead of a repo-wide hunt.
export const APP_STORE_URL =
  "https://apps.apple.com/app/pleasant-routes/id6778541395";
